import { useState, useEffect } from "react";
import {
  Box,
  HStack,
  Pressable,
  ScrollView,
  Text,
  Spinner,
  VStack,
  useMediaQuery,
} from "native-base";
import CryptoJS from "crypto-js";
import { COLORS } from "../../utils/colors";
import MobileHeader from "../../layout/header/mobileHeader";
import WebHeader from "../../layout/header/webHeader";
import Breadcrumbs from "../../components/breadcrumb";
import { MOBILE_VIEW_WIDTH } from "../../utils/screens";
import { COMMONFONTWEIGHT } from "../../utils/fonts";
import CommonHeading from "../../components/headings";
import ViewUploadImageCards from "../../containers/viewUploadImageCards";
import {
  deleteImagesPermanently,
  getApprovedImages,
  getWorkflowAPI,
  putReviewflowAPI,
} from "../../api/apis/workflow";
import { hasPermission } from "../../utils/permission";
import { Toaster } from "../../components/toaster";
import { PhotoDisplayFullScreen, VideoDisplayFullScreen } from "../requestEventDetailPage/photosListing/modalChildren";
import ImageViewer from "../../components/imageViewer";
import { getNotificationAPI } from "../../api/apis/notification";
import config from "../../utils/config";

const PhotoDetailPage = ({ title = "" }) => {
  const toaster = Toaster();
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });
  const eventBytes = CryptoJS.AES.decrypt(
    sessionStorage.getItem("event"),
    config.eventKey
  );
  const eventString = eventBytes.toString(CryptoJS.enc.Utf8);
  const selectedEvent = JSON.parse(eventString);
  const eventTab = selectedEvent.type === "event" ? "Event" : "MICE";
  const breadcrumbDetails = {
    activeTab: { name: "Home", path: "/home" },
    activeMenu: { name: `${eventTab} Detail`, path: "/event-detail" },
    activeActivePage: {
      name: "Media",
      path: "/event-detail/photo-detail",
    },
  };
  const [images, setImages] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedImagePath, setSelectedImagePath] = useState("");
  const [selectedVideo, setSelectedVideo] = useState("");
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [workflow, setWorkflow] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    AddWorkflow();
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const AddWorkflow = async () => {
    let res = await getWorkflowAPI();
    if (res.error) {
      toaster(res.message, "error", "error");
      return;
    } else {
      let workflows = {};
      res.data.data.data?.map((item) => {
        if (item.name === "EventWorkflow") {
          workflows["event"] = item;
        }
        if (item.name === "ImageWorkflow") {
          workflows["image"] = item;
        }
        if (item.name === "ReviewWorkflow") {
          workflows["review"] = item;
        }
      });
      setWorkflow(workflows);
      if (
        workflows &&
        workflows["image"] &&
        workflows["image"]["_id"] &&
        selectedEvent &&
        selectedEvent._id
      )
        getImages(selectedEvent._id);
    }
  };

  const getImages = async (event_id, page_no = 1, per_page = 100000) => {
    setIsLoading(true);
    let res = await getApprovedImages(event_id, page_no, per_page);
    if (res.error) {
      toaster(res.message, "error", "error");
      return;
    } else {
      setImages(res?.data?.data?.data);
    }
    setIsLoading(false);
  };

  const refreshImages = () => {
    // Get event ID from sessionStorage to ensure we have it
    try {
      const eventBytes = CryptoJS.AES.decrypt(
        sessionStorage.getItem("event"),
        config.eventKey
      );
      const eventString = eventBytes.toString(CryptoJS.enc.Utf8);
      const event = JSON.parse(eventString);
      
      if (event && event._id) {
        getImages(event._id);
      }
    } catch (error) {
      console.error("Error getting event id from sessionStorage:", error);
      // Fallback to selectedEvent if sessionStorage fails
      if (selectedEvent && selectedEvent._id) {
        getImages(selectedEvent._id);
      }
    }
  };

  const openModal = () => {
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const handleImages = (index, path) => {
    setSelectedImagePath(path);
    openModal();
  };

  const handleVideoClick = (videoUrl) => {
    setSelectedVideo(videoUrl);
    setShowVideoModal(true);
    // Scroll to top when video modal opens
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const closeVideoModal = () => {
    setShowVideoModal(false);
    setSelectedVideo("");
  };

  const handleSelectedImages = (index) => {
    approvePhotoWorkflow(index, "REJECT_IMAGES");
  };

  const approvePhotoWorkflow = async (selectedImageIndex) => {
    if (selectedImageIndex >= 0) {
      let payload = {
        image_ids: [
          {
            image_id: images[0].approved_images[selectedImageIndex]._id,
            media_id: images[0].approved_images[selectedImageIndex].media_id,
          },
        ],
      };
      let res = await deleteImagesPermanently(payload);
      if (res.error) {
        toaster(res.message, "error", "error");
        return;
      } else {
        toaster("Deleted Successfully", "success", "success");
      }
      AddWorkflow();
    }
  };

  return (
    <Box bg={COLORS.THEME_BACKGROUND} pb={8} pr={2} minHeight={"100vh"}>
      <Box bg={COLORS.WHITE_COLOR}>
        {MobileWindow ? (
          <MobileHeader showTabs={false} />
        ) : (
          <>
            <WebHeader showTabs={false} />
            <Box p={4} px={"5rem"}>
              <Breadcrumbs path={breadcrumbDetails} />
            </Box>
          </>
        )}
      </Box>
      <VStack pt={7} pl={MobileWindow ? "3" : "6rem"} space={5}>
        <CommonHeading text="Media" />
        <Text
          fontWeight={COMMONFONTWEIGHT.MEDIUM_FONT_WEIGHT}
          fontSize={"18px"}
        >
          {title}
        </Text>
        {isLoading ? (
          <Box mt={10} flex={1} alignItems="center" justifyContent="center">
            <Spinner color={COLORS.THEME_COLOR} size="lg" />
          </Box>
        ) : (
          <ScrollView>
              <HStack flex={1}
                w={"100%"}
                // flexWrap={"wrap"}
                flexDirection={"column"}>
                {
                  images && images[0] && images[0].approved_images && (
                    <ImageViewer
                      path
                      images={images[0].approved_images}
                      toolbar={true}
                      showSelectAll={true}
                      showUploadedBy={true}
                      onVideoClick={handleVideoClick}
                      onImagesDeleted={refreshImages}
                    />
                  )
                }
              </HStack>
          </ScrollView>
        )}
      </VStack>
      {showModal && (
        <PhotoDisplayFullScreen
          selectedImage={selectedImagePath}
          setSelectedImage={setSelectedImagePath}
          closeModal={closeModal}
          h="90%"
        />
      )}
      {showVideoModal && (
        <VideoDisplayFullScreen
          selectedVideo={selectedVideo}
          setSelectedVideo={setSelectedVideo}
          closeModal={closeVideoModal}
          h="90%"
        />
      )}
    </Box>
  );
};

export default PhotoDetailPage;
